import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import classNames from 'classnames';
import ConfigProvider from '../config-provider';
import '@shopee-ui-react/iconfont';
var Icon =
/*#__PURE__*/
React.forwardRef(function (_a, ref) {
  var customizePrefixCls = _a.prefixCls,
      _a$viewBox = _a.viewBox,
      viewBox = _a$viewBox === void 0 ? '0 0 1024 1024' : _a$viewBox,
      _a$spin = _a.spin,
      spin = _a$spin === void 0 ? false : _a$spin,
      tabIndex = _a.tabIndex,
      svg = _a.svg,
      type = _a.type,
      className = _a.className,
      rotate = _a.rotate,
      style = _a.style,
      children = _a.children,
      onClick = _a.onClick,
      extraProps = __rest(_a, ["prefixCls", "viewBox", "spin", "tabIndex", "svg", "type", "className", "rotate", "style", "children", "onClick"]);

  var _React$useContext = React.useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('icon', customizePrefixCls);
  var normalIconClasses = classNames(className, prefixCls, "seller-icon-".concat(type), 'shopee-seller-iconfont', _defineProperty({}, "".concat(prefixCls, "-spin"), spin));
  var iconStyle = rotate ? Object.assign({
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  }, style) : style;
  var svgClasses = classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-spin"), spin));
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  if (svg) {
    var svgBaseProps = {
      width: '1em',
      height: '1em',
      fill: 'currentColor',
      'aria-hidden': 'true',
      focusable: 'false',
      viewBox: viewBox
    };
    var svgElement = null;

    if (
    /*#__PURE__*/
    React.isValidElement(svg)) {
      svgElement = svg;
    } else if (typeof svg === 'function') {
      svgElement = svg();
    } else {
      svgElement =
      /*#__PURE__*/
      React.createElement("img", {
        tabIndex: iconTabIndex,
        src: svg,
        alt: prefixCls
      });
    }

    return (
      /*#__PURE__*/
      React.cloneElement(svgElement, Object.assign(Object.assign({
        className: svgClasses,
        style: iconStyle
      }, svgBaseProps), {
        onClick: onClick,
        ref: ref
      }))
    );
  }

  return (
    /*#__PURE__*/
    React.createElement("i", _extends({
      ref: ref,
      tabIndex: iconTabIndex,
      onClick: onClick,
      className: normalIconClasses,
      style: iconStyle
    }, extraProps), children)
  );
});
Icon.displayName = 'Icon';
export default Icon;